import React from "react";
import { Link } from "../Link";
import { IconList } from "../IconList";
import { Icons } from "@/types/icons";
import { PreviewLocationBlockProps } from "./types";
import { checkValidURL } from "@/utils/formHelper";

//TODO: add classNames to props to make component ui-headless
export const PreviewLocationBlock = ({ data, title }: PreviewLocationBlockProps) => {
  const { address, numeration, city, zipCode, state, country, fullAddress } = data || {};

  if (!data || (!address && !numeration && !city && !zipCode && !state && !country)) {
    return null;
  }

  const addressMapsURL = `http://maps.google.com/?q=${fullAddress}`;

  return (
    <div className="u-card business-location">
      <IconList
        iconItem
        items={{
          icon: Icons.location,
          title,
        }}
        tag={"h6"}
        semibold
      />
      <Link
        className="business-link"
        href={checkValidURL(addressMapsURL) || ""}
        externalLink
        prefetch={false}>
        {fullAddress}
      </Link>
    </div>
  );
};
